import { SecondhandTaxesLandingPageSection } from '../../constants'

export const getTipSectionContent = () => ({
  componentId: SecondhandTaxesLandingPageSection.Tip,
  testId: 'no-changes-to-taxes--tip-section',
  text: {
    title: 'secondhand_taxes.tip.title',
    description: 'secondhand_taxes.tip.description',
  },
})
